import {formattedPropertyModel, intlShape, utils} from '@wallaby-ui/core';
import PropTypes from 'prop-types';
import * as React from 'react';
import {injectIntl} from 'react-intl';

import {DEFAULT_RIGHT_COLOR} from './GradientProgressFormatter';
import styles from './ProgressFormatter.less';
import {
  CellRendererParams,
  CELL_RENDERER_PARAMS,
  CELL_RENDERER_PARAMS_AG,
} from 'src/js/model/cell_renderer_params';

class ProgressFormatter extends React.PureComponent {
  render() {
    const {colDef, intl, value} = this.props;
    const decimalValue = utils.NumberUtils.roundToWantedDecimals(
      value * 100,
      2
    );
    // get color from config
    const formatterParams = new CellRendererParams(
      colDef[CELL_RENDERER_PARAMS_AG] || colDef[CELL_RENDERER_PARAMS] || {}
    );
    const backgroundColor = formatterParams.getColor()
      ? formatterParams.getColor()
      : utils.ColorUtils.rgbToHex(DEFAULT_RIGHT_COLOR);

    const propDefinition = new formattedPropertyModel.FormattedProperty({
      type: formattedPropertyModel.FORMATTED_PROPERTY_TYPE_PERCENT,
    });
    const formattedValue = formattedPropertyModel.FormattedProperty.formatValue(
      propDefinition,
      value,
      intl
    );
    return (
      <div
        className={styles.dlProgressFormatter}
        style={{
          backgroundColor,
          width: `${decimalValue}%`,
        }}
      >
        <div className={styles.dlProgressFormatterValue}>{formattedValue}</div>
      </div>
    );
  }
}

ProgressFormatter.displayName = 'ProgressFormatter';

ProgressFormatter.propTypes = {
  intl: intlShape.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

ProgressFormatter.defaultProps = {
  value: undefined,
};

export default injectIntl(ProgressFormatter);
